const ElementMeasurementPort = {
  add: function (app) {
    const observers = new Map();
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const elementId = entry.target.id;
        const config = observers.get(elementId);
        if (config) {
          measureElement(entry.target, config, app);
        }
      });
    });

    const measureElement = (element, config, app) => {
      const { elementId, maxLines } = config;

      const computedStyle = window.getComputedStyle(element);
      let lineHeight = parseFloat(computedStyle.lineHeight);

      if (isNaN(lineHeight) || lineHeight === 0) {
        const fontSize = parseFloat(computedStyle.fontSize);
        lineHeight = fontSize * 1.5;
      }

      const scrollHeight = element.scrollHeight;
      const maxHeight = lineHeight * maxLines;

      const tolerance = 2;
      const exceedsMaxLines = scrollHeight > maxHeight + tolerance;

      app.ports.onElementMeasured.send({
        elementId: elementId,
        scrollHeight: scrollHeight,
        clientHeight: element.clientHeight,
        lineHeight: lineHeight,
        exceedsMaxLines: exceedsMaxLines,
      });
    };

    const setupObserver = (element, config, app) => {
      const mutationObserver = new MutationObserver((mutations) => {
        let shouldMeasure = false;

        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData" ||
            (mutation.type === "attributes" &&
              (mutation.attributeName === "style" || mutation.attributeName === "class"))
          ) {
            shouldMeasure = true;
          }
        });

        if (shouldMeasure) {
          requestAnimationFrame(() => measureElement(element, config, app));
        }
      });

      mutationObserver.observe(element, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });

      resizeObserver.observe(element);

      return mutationObserver;
    };

    app.ports.measureElement.subscribe(function (config) {
      const { elementId } = config;
      const element = document.getElementById(elementId);

      if (!element) {
        console.warn(`Element with id "${elementId}" not found for measurement`);
        return;
      }

      if (observers.has(elementId)) {
        const existingObserver = observers.get(elementId).observer;
        existingObserver.disconnect();
        resizeObserver.unobserve(element);
      }

      const observer = setupObserver(element, config, app);
      observers.set(elementId, { ...config, observer });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => measureElement(element, config, app));
      });
    });

    return function cleanup() {
      observers.forEach(({ observer }, elementId) => {
        observer.disconnect();
        const element = document.getElementById(elementId);
        if (element) {
          resizeObserver.unobserve(element);
        }
      });
      observers.clear();
      resizeObserver.disconnect();
    };
  },
};

module.exports = ElementMeasurementPort;
